module.exports = __webpack_public_path__ + "img/ly.e2b06211.jpg";